// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EyeInvisibleFilledSvg from "@ant-design/icons-svg/es/asn/EyeInvisibleFilled";
import AntdIcon from '../components/AntdIcon';

var EyeInvisibleFilled = function EyeInvisibleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EyeInvisibleFilledSvg
  }));
};

EyeInvisibleFilled.displayName = 'EyeInvisibleFilled';
export default /*#__PURE__*/React.forwardRef(EyeInvisibleFilled);